// src/features/portal/documents/documentsSlice.js
import { createSlice } from "@reduxjs/toolkit";

// MOCK DATA: Simula la respuesta de una DB real
const INITIAL_DOCS = [
  {
    id: "doc_001",
    name: "RUT Actualizado 2024.pdf",
    category: "Legal",
    size: "1.2 MB",
    updatedAt: "2024-01-15T10:00:00Z",
    version: 2,
    owner: "Contabilidad",
    accessLevel: "private",
  },
  {
    id: "doc_002",
    name: "Cámara de Comercio.pdf",
    category: "Legal",
    size: "0.8 MB",
    updatedAt: "2024-01-20T14:30:00Z",
    version: 1,
    owner: "Legal",
    accessLevel: "team",
  },
  {
    id: "doc_003",
    name: "Estados Financieros Q4.xlsx",
    category: "Fiscal",
    size: "450 KB",
    updatedAt: "2024-02-01T09:15:00Z",
    version: 3,
    owner: "Revisoría",
    accessLevel: "private",
  },
];

const initialState = {
  items: INITIAL_DOCS,
  loading: false,
  error: null,
  uploading: false,
};

const documentsSlice = createSlice({
  name: "documents",
  initialState,
  reducers: {
    // Acción síncrona para simular subida en Demo
    addMockDocument: (state, action) => {
      state.items.unshift(action.payload);
    },
    // Acción síncrona para simular nueva versión
    updateMockDocumentVersion: (state, action) => {
      const { id, newVersion } = action.payload;
      const index = state.items.findIndex((d) => d.id === id);
      if (index !== -1) {
        state.items[index] = {
          ...state.items[index],
          version: newVersion,
          updatedAt: new Date().toISOString(),
        };
      }
    },
  },
});

export const { addMockDocument, updateMockDocumentVersion } =
  documentsSlice.actions;
export default documentsSlice.reducer;
